import { environment } from '../../environments/environment';

/** Unidades liberadas neste build (piloto do front novo). Vazia = todas. */
export function unidadesPermitidas(): number[] {
  return (environment as { unidadesPermitidas?: number[] }).unidadesPermitidas ?? [];
}

export function unidadePermitida(unidade: unknown, lista: number[] = unidadesPermitidas()): boolean {
  if (lista.length === 0) return true;
  const id = Number(unidade);
  return Number.isFinite(id) && lista.includes(id);
}
